import { getExhibitionistGridWidgetConfig } from '@wix/da-shared-react/pkg/widgets/Exhibitionist/widgetConfig';
import {
  getFeaturedDeviationWidgetConfig,
  getFeaturedPostWidgetConfig,
} from '../../UserWidgets.deviation_gruser/FeaturedDeviation/widgetConfig';
import {
  getWatchersWidgetConfig,
  getWatchingWidgetConfig,
} from '../../UserWidgets.deviation_gruser/WatchedDeviants/widgetConfig';
import { getSupportersWidgetConfig } from '../../UserWidgets.deviation_gruser/Supporters/widgetConfig';
import {
  getGroupListAdminsWidgetConfig,
  getGroupListMembersWidgetConfig,
} from '../../UserWidgets.deviation_gruser/GroupList/widgetConfig';
import { getFeedWidgetConfig } from '../../UserWidgets.deviation_gruser/Feed/widgetConfig';
import { getProfileCommentsWidgetConfig } from '../../UserWidgets.deviation_gruser/ProfileComments/widgetConfig';
import { getLlamaFarmWidgetConfig } from '../../UserWidgets.deviation_gruser/LlamaFarm/widgetConfig';
import { getDonationsWidgetConfig } from '../../UserWidgets.deviation_gruser/Donations/widgetConfig';
import { getGroupAdminsWidgetConfig } from '../../GroupWidgets.deviation_gruser/Admins/widgetConfig';
import getActiveMembersWidgetConfig from '../../GroupWidgets.deviation_gruser/ActiveMembers/widgetConfig';
import getGroupMembersWidgetConfig from '../../GroupWidgets.deviation_gruser/GroupMembers/widgetConfig';
import getNewestMembersWidgetConfig from '../../GroupWidgets.deviation_gruser/NewestMembers/widgetConfig';
import getGroupAboutWidgetConfig from '../../GroupWidgets.deviation_gruser/GroupAbout/widgetConfig';
import { getTiersPromoWidgetConfig } from '../../UserWidgets.deviation_gruser/TiersPromoBox/widgetConfig';
import { getCustomWidgetConfig } from '../../UserWidgets.deviation_gruser/Custom/widgetConfig';
import { getMegaboxWidgetConfig } from '../../UserWidgets.deviation_gruser/Megabox/widgetConfig';
import getCoverDeviationWidgetConfig from '../../UserWidgets.deviation_gruser/CoverDeviation/widgetConfig';
import { getAboutMeWidgetConfig } from '../../UserWidgets.deviation_gruser/AboutMe/widgetConfig';
import { getBadgesSpotlightConfig } from '../../UserWidgets.deviation_gruser/BadgesSpotlight/widgetConfig';
import { getDeviousnessConfig } from '../../UserWidgets.deviation_gruser/Deviousness/widgetConfig';

export const getHomeWidgetConfigs = ({ t, dispatch }) => ({
  deviousness: getDeviousnessConfig({ t, dispatch }),
  coverDeviation: getCoverDeviationWidgetConfig({ t, dispatch }),
  megabox: getMegaboxWidgetConfig({ t, dispatch }),
  tiers: getTiersPromoWidgetConfig({ t, dispatch }),
  groupAbout: getGroupAboutWidgetConfig({ t, dispatch }),
  about: getAboutMeWidgetConfig({ t, dispatch }),
  exhibitionist: getExhibitionistGridWidgetConfig({ t, dispatch }),
  featuredDeviation: getFeaturedDeviationWidgetConfig({ t, dispatch }),
  watchers: getWatchersWidgetConfig({ t, dispatch }),
  watching: getWatchingWidgetConfig({ t, dispatch }),
  supporters: getSupportersWidgetConfig({ t, dispatch }),
  groupListMembers: getGroupListMembersWidgetConfig({ t, dispatch }),
  groupListAdmins: getGroupListAdminsWidgetConfig({ t, dispatch }),
  llamaFarm: getLlamaFarmWidgetConfig({ t, dispatch }),
  groupAdmins: getGroupAdminsWidgetConfig({ t, dispatch }),
  activeMembers: getActiveMembersWidgetConfig({ t, dispatch }),
  groupMembers: getGroupMembersWidgetConfig({ t, dispatch }),
  newestMembers: getNewestMembersWidgetConfig({ t, dispatch }),
  papiCustombox: getCustomWidgetConfig({ t, dispatch }),
  featuredPost: getFeaturedPostWidgetConfig({ t, dispatch }),
  feed: getFeedWidgetConfig({ t, dispatch }),
  donations: getDonationsWidgetConfig({ t, dispatch }),
  comments: getProfileCommentsWidgetConfig({ t, dispatch }),
  badgesSpotlight: getBadgesSpotlightConfig({ t, dispatch }),
});
